import React, {Component} from 'react';
import {Radio, Row} from "antd";
import {app} from "../../app";
import SuNearby from "./SuNearby"
import ApplyClass from "./ApplyClass"
import RecentClass from "./RecentClass"

const RadioGroup = Radio.Group
const RadioButton = Radio.Button

class SignUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sel_tab: null
        }
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.setData({ sel_tab: '1' })
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    componentWillUnmount() {
        this._isMounted = false;
    }

    parentTab = async (obj) =>{
        await this.setData({ sel_tab: obj.sel_tab })
    }

    /**
     * 选项选择变更
     * @param e
     */
    handleTabChange = (e) => {
        let { value } = e.target
        let { sel_tab } = this.state
        if (value === sel_tab) return
        this.setData({ sel_tab: value })
    }

    render() {
        let { sel_tab } = this.state,
            content,
            tab_disabled = !sel_tab
        switch (sel_tab) {
            case "1":
                //content = (<SuNearby/>)
                content = (<SuNearby parent={this.parentTab} history={this.props.history} />)
                //content = (<RecentClass history={this.props.history} />)
                break
            case "2":
                content = (<ApplyClass history={this.props.history} />)
                //content = (<SuNearby history={this.props.history} />)
                //content = (<ApplyClass/>)
                break
        }
        return(
            <div className="st-sing-up">
                <Row className="top-title">
                    <RadioGroup size="large" value={sel_tab} buttonStyle="solid" onChange={this.handleTabChange}>
                        <RadioButton className='no-select' value="1" disabled={tab_disabled}>近期开班</RadioButton>
                        {/*<RadioButton className='no-select' value="2" disabled={tab_disabled}>申请开班</RadioButton>*/}
                    </RadioGroup>
                </Row>
                <Row className="content">
                    {content}
                </Row>
            </div>
        );
    }
}
export default SignUp;



// WEBPACK FOOTER //
// ./src/routes/skillTrain/SignUp.jsx